/**
 * MKS-349 follow-up — API client for the bulk "mark as paid" action.
 *
 * Types mirror `backend/src/api/schemas/invoiceBulkPaid.ts` field for field.
 */
import { apiGet, apiPost } from './client';

export interface BulkPaidPreview {
  issuedBefore: string;
  count: number;
  totalAmount: number;
  /** The run would exceed the server's per-action limit and will be refused. */
  tooMany: boolean;
  maxAllowed: number;
}

export interface BulkPaidResult {
  /** Empty when nothing matched — there is then no batch to undo. */
  batchId: string;
  issuedBefore: string;
  marked: number;
}

export interface BulkPaidBatch {
  batchId: string;
  issuedBefore: string | null;
  at: string;
  byUserId: number | null;
  marked: number;
  undone: number;
}

export interface BulkPaidUndoResult {
  batchId: string;
  reverted: number;
  /** Invoices of the batch the undo left alone (re-dated, or already undone). */
  skipped: number;
}

export async function previewBulkPaid(issuedBefore: string): Promise<{ data: BulkPaidPreview }> {
  return apiGet(`/invoices/bulk-paid/preview?issuedBefore=${encodeURIComponent(issuedBefore)}`);
}

export async function applyBulkPaid(issuedBefore: string): Promise<{ data: BulkPaidResult }> {
  return apiPost('/invoices/bulk-paid', { issuedBefore });
}

export async function fetchBulkPaidBatches(): Promise<{ data: BulkPaidBatch[] }> {
  return apiGet('/invoices/bulk-paid/batches');
}

export async function undoBulkPaid(batchId: string): Promise<{ data: BulkPaidUndoResult }> {
  return apiPost('/invoices/bulk-paid/undo', { batchId });
}
